import { Box } from "@mui/material";
import logoImage from "../assets/logo-login.svg";
import LoginForm from "./LoginForm";

const LayoutLogin = () => {
  return (
    <Box
      sx={{
        minWidth: "100vw",
        minHeight: "100vh",
        backgroundColor: "white",
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "column",
          lg: "row",
          xl: "row",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "#182250",
          minWidth: {
            xs: "100%",
            sm: "100%",
            md: "100%",
            lg: "65%",
            xl: "65%",
          },
          minHeight: {
            xs: "250px",
            sm: "300px",
            md: "500px",
            lg: "inherit",
            xl: "inherit",
          },
          display: "flex",
          justifyContent: "center",
          alignItems: {
            xs: "center",
            sm: "center",
            md: "center",
            lg: "center",
            xl: "center",
          },
        }}
      >
        <Box
          sx={{
            width: {
              xs: "315px",
              sm: "315px",
              md: "315px",
              lg: "315px",
              xl: "315px",
            },
            height: {
              xs: "146px",
              sm: "146px",
              md: "146px",
              lg: "146px",
              xl: "146px",
            },
          }}
        >
          <img src={logoImage} alt="image_login"/>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoginForm />
      </Box>
    </Box>
  );
};

export default LayoutLogin;
